import axios from 'axios';

export default axios.create({
  baseURL: 'https://cosahh.com/'
  //baseURL: 'https://cosahh-149311.ew.r.appspot.com/'
  // baseURL: 'http://localhost:8000/'
});